import React from 'react';
import classNames from 'classnames';
import { times } from 'lodash';

import Icon from 'assets/icons';

import styles from './ProgressBar.module.scss';

const CHECKED_STEP = <Icon.Checkmark className={styles.checkmark} />;

interface ProgressBarProps {
  type: 'Bar' | 'Node';
  className: string;
  totalSteps: number;
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  className,
  currentStep,
  totalSteps,
  type = 'Bar',
}) => {
  return (
    <div className={classNames(className, styles.container)}>
      {times(totalSteps, (step) => {
        const complete = step < currentStep;
        const current = currentStep === step;
        const nodeContent = type === 'Node' ? complete && CHECKED_STEP : '';
        const classes = classNames({
          [styles[`section-${type}`]]: type,
          [styles.complete]: complete,
          [styles.current]: current,
        });

        return (
          <div key={step} className={classes}>
            {type === 'Bar' && (
              <div className={styles.progressBubble}>
                {currentStep + 1} of {totalSteps}
              </div>
            )}
            {type === 'Node' && <div className={styles.circle}>{nodeContent}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
